import type { StudioLogsActions } from '../../actions/studio/logs';
import type { LogEntry } from '../../types/Log';
import { RESET_STUDIO_ACTION } from '../consts';

export interface State {
    entries: LogEntry[];
    isFetchingPrevious: boolean;
    isFetching: boolean;
    hasPreviousLogs: boolean;
    hasLogs: boolean;
    nextToken?: string;
    backToken?: string;
}

const getDefaultState = (): State => ({
    entries: [],
    isFetchingPrevious: false,
    isFetching: false,
    hasPreviousLogs: true,
    hasLogs: false
});

const studioLogsReducer = (state = getDefaultState(), action: StudioLogsActions | null): State => {
    switch (action?.type) {
        case 'SET_STUDIO_LOGS_FETCHING_PREVIOUS': {
            return {
                ...state,
                isFetchingPrevious: action.data
            };
        }

        case 'SET_STUDIO_LOGS_FETCHING': {
            return {
                ...state,
                isFetching: action.data
            };
        }

        case 'SET_STUDIO_LOGS': {
            return {
                ...state,
                entries: action.data.logs,
                hasPreviousLogs: action.data.hasPreviousLogs ?? state.hasPreviousLogs
            };
        }

        case 'SET_STUDIO_LOGS_TOKEN': {
            return {
                ...state,
                nextToken: action.data.nextToken,
                backToken: action.data.backToken
            };
        }

        case 'SET_STUDIO_LOGS_HAS_LOGS': {
            return {
                ...state,
                hasLogs: action.data
            };
        }

        case RESET_STUDIO_ACTION: {
            return getDefaultState();
        }

        default: {
            return state;
        }
    }
};

export default studioLogsReducer;
